// Runtime feature flags.
//
// Source of truth: `window.env` (set by `config.js`, which is mounted at runtime
// from a per-environment Kubernetes ConfigMap). Missing keys default to ON so
// that adding a new feature doesn't accidentally hide it in environments whose
// ConfigMap hasn't been updated yet.

function toBool(value, defaultValue) {
  if (value === undefined || value === null) return defaultValue;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') {
    const lowered = value.trim().toLowerCase();
    if (lowered === 'false' || lowered === '0' || lowered === '') return false;
    return true;
  }
  return Boolean(value);
}

export function resolveFeatureFlags(env) {
  const e = env ?? {};
  return {
    etl: toBool(e.VUE_APP_FEATURE_ETL, true),
  };
}

export const featureFlags = resolveFeatureFlags(
  typeof window !== 'undefined' ? window.env : undefined
);
